import {
    getProduct,
    listProducts
} from './queries';
import {
    createProduct,
    deleteProduct,
    updateProduct,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {Product} from "../types.ts";
import {generateClient} from 'aws-amplify/api';
import {
    notifyError,
    notifySuccess
} from "../../../components/ServiceNotifications.tsx";


export type ListProducts = {
    listProducts: { items: Product[] }
}

export type GetProduct = {
    getProduct: Product
}

export type CreateProduct = {
    createProduct: Product
}

export type UpdateProduct = {
    updateProduct: Product
}

export type DeleteProduct = {
    deleteProduct: string
}


const client = generateClient();


export const fetchRecords = async (filter: object) => {
    try {
        const response = await client.graphql<GraphQLQuery<ListProducts>>({
                                                                              query: listProducts,
                                                                              variables: {filter: filter},
                                                                          });
        return response.data?.listProducts.items;
    } catch (e) {
        notifyError(e)
    }
};

export const fetch = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<GetProduct>>({
                                                                            query: getProduct,
                                                                            variables: {id: id},
                                                                        });
        return response.data?.getProduct;
    } catch (e) {
        notifyError(e)
    }
};

export const add = async (payload: object) => {

    try {
        const response = await client.graphql<GraphQLQuery<CreateProduct>>({
                                                                               query: createProduct,
                                                                               variables: {input: payload},
                                                                           });
        console.debug('in the service response', response);
        notifySuccess('Product created');
        return response.data?.createProduct;
    } catch (e) {
        notifyError(e)
    }
};

export const update = async (id: string, record: Product) => {

    console.debug('IN UPDATE', id, record);

    delete record.created;
    delete record.updated;

    try {
        const response = await client.graphql<GraphQLQuery<UpdateProduct>>({
                                                                               query: (updateProduct),
                                                                               variables: {input: record},
                                                                           });
        notifySuccess('Product updated');
        return response.data?.updateProduct;
    } catch (e) {
        notifyError(e)
    }
};

export const deleteRecord = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<DeleteProduct>>({
                                                                               query: (deleteProduct),
                                                                               variables: {input: {id: id}},

                                                                           });
        notifySuccess('Product deleted');
        return response.data?.deleteProduct;
    } catch (e) {
        notifyError(e)
    }
};
